import React from "react"
import { FaFileInvoiceDollar } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton, } from "components"
import classes from "./OrderDetailsPrintInvoiceButton.module.scss"

const OrderDetailsPrintInvoiceButton = props => {
  const { order } = props

  const [t, i18n] = useTranslation()

  const handlePrintOrder = async () => {
    sessionStorage.setItem(
      "data",
      JSON.stringify({
        type: "orderInvoice",
        value: [order]
      })
    )

    window.open("/print", "_blank")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={classes["container"]}
      onClick={handlePrintOrder}
    >
      <IconButton
        icon={FaFileInvoiceDollar}
        size={18}
        loadingColor="black"
      />
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("پرینت_فاکتور")}
      </span>
    </div>
  )
}

export default OrderDetailsPrintInvoiceButton